class Regimesocial {
    constructor(data) {
      this.Id = data.Id;
      this.Name = data.Name;

    }
  }
  
  export default Regimesocial;
  